import englishMessages from 'ra-language-english';
import common from './common';
import auth from './auth';
import dashboard from './dashboard';
import qrphoneResources from './qrphone';
import onboarding from './onboarding';

const en = {
  ...englishMessages,
  ra: {
    ...englishMessages.ra,
    action: {
      ...englishMessages.ra.action,
      add_filter: 'Add filter',
      clear_input_value: 'Clear field',
      close: 'Close',
    },
    page: {
      ...englishMessages.ra.page,
      dashboard: 'Dashboard',
    },
  },
  common,
  auth,
  dashboard,
  onboarding,
  fields: {
    name: 'Name',
    description: 'Description',
    status: 'Status',
    email: 'Email',
    createdAt: 'Created at',
    updatedAt: 'Last updated',
  },
  resources: {
    ...qrphoneResources,
  },
  user: {
    profile: 'Profile',
    settings: 'Settings',
    change_password: 'Change Password',
  },
  pages: {
    profile: {
      title: 'My profile',
      data: 'Personal data',
      saved: 'Profile updated',
      change_password: 'Change password',
      current_password: 'Current password',
      new_password: 'New password',
      confirm_password: 'Confirm new password',
      password_changed: 'Password changed',
      password_mismatch: 'Passwords do not match',
    },
    system: {
      title: 'System',
      tabs: {
        health: 'Service health',
        devices: 'Devices',
        routing: 'Routing health',
      },
      routing: {
        intro:
          'A kiosk can only receive calls if its default staff is an agent with an active device. Kiosks with misconfigured routing are listed here.',
        all_ok: 'Every active kiosk has a default staff that can answer calls.',
        summary: '%{broken} of %{total} active kiosks have misconfigured routing.',
        kiosk: 'Kiosk',
        organization: 'Organization',
        default_staff: 'Default staff',
        problem: 'Problem',
        status: {
          no_default: 'No default staff',
          default_not_agent: 'Default staff is not a valid agent',
          default_no_device: 'Default staff has no device',
        },
      },
      health: {
        ok: 'Operational',
        down: 'Unavailable',
        version: 'Version',
        uptime: 'Uptime',
        refresh_note: 'Data refreshes automatically every 5 seconds.',
        counters: {
          activeRooms: 'Active rooms',
          busyParticipants: 'Participants in call',
          ringingStaff: 'Ringing staff',
          queuedCalls: 'Queued calls',
          watchedCalls: 'Watched calls',
          pendingTimers: 'Pending timers',
        },
      },
      devices: {
        name: 'Name',
        email: 'Email',
        role: 'Role',
        organization: 'Organization',
        devices: 'Devices',
        status: 'Status',
        none: 'No devices',
        unknown: 'Unknown',
        can_receive: 'Can receive calls',
        cannot_receive: 'Cannot receive calls',
      },
    },
    serverSettings: {
      title: 'Server settings',
      saved: 'Settings saved',
      secret_note: 'Secret fields never display the stored value: leave them blank to keep it.',
      secret_placeholder: 'Unchanged',
      tabs: {
        callserver: 'Call server',
        mail: 'Mail & payments',
      },
      callserver: {
        servertype: 'Server type',
        type_custom: 'Self-hosted server',
        type_hosted: 'Managed provider',
        url: 'Server URL',
        username: 'Username',
        password: 'Password',
        account_sid: 'Account identifier',
        auth_token: 'Auth token',
      },
      mail: {
        server: 'Mail server',
        port: 'Port',
        user: 'User',
        sender: 'Sender',
        password: 'Mail password / API key',
        payments_key: 'Payments API key',
      },
      payments: {
        title: 'Payments',
        description: 'Decides how new clients are taken on by this instance.',
        mode: 'Operating mode',
        mode_linked: 'Linked to the payment platform',
        mode_manual: 'Manual sign-up',
        mode_help_linked:
          'The visitor picks a plan and is taken to the payment platform to complete the charge.',
        mode_help_manual:
          'Nothing is charged online. The visitor picks a plan and leaves a request that you resolve from the sign-up requests list.',
        platform_url: 'Payment platform address',
        platform_client_id: 'Client identifier',
        platform_secret: 'Access secret',
        request_email: 'Sign-up request address',
        request_email_help:
          'Address notified of every new request. Left blank, requests are still recorded but no notification is sent.',
        legacy_key_help:
          'Credential of the previous charging integration. Kept while the move to the payment platform is completed.',
      },
    },
    login: {
      subtitle: 'Administration panel',
      login_button: 'Sign In',
      forgot_password: 'Forgot your password?',
    },
    dashboard: {
      welcome: 'Welcome, %{name}',
      intro: 'Pick a section from the menu to get started.',
      calls_today: 'Calls today',
      calls_week: 'Calls (last 7 days)',
      clients: 'Clients',
      recent_calls: 'Latest calls',
      service_status: 'Service status',
      service_ok: 'Operational',
      service_down: 'Unavailable',
      active_calls: 'Active calls',
      queued_calls: 'Queued calls',
      no_data: 'No results found',
      no_data_description: 'No data available at this time',
      desktop_window_title: 'Desktop window for calls',
      desktop_window_body:
        'The softphone can be installed as its own desktop window: it announces calls with the window minimised, gets its own taskbar icon and, if you choose to, can start automatically when the computer starts. To open it, use the "Receive calls" button in the top bar. Inside, on the staff screen, you will find the "Install application" and "Enable automatic start" options.',
    },
  },
  validation: common.validation,
  notifications: common.notifications,
};

export default en;
